import { render, staticRenderFns } from "./ApiSms.vue?vue&type=template&id=0005454c&"
import script from "./ApiSms.vue?vue&type=script&lang=js&"
export * from "./ApiSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports